'use client';

import { Icons } from '@/components/Shares/Icons';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { Container, Modal, Stack } from '@mantine/core';
import classes from '../Shares/Modal.module.css';
import { SearchAction } from './SearchAction';
import { SearchCategory } from './SearchCategory';
import { SearchTopGames } from './SearchTopGames';
export const SearchModal: React.FC = () => {
  const {
    openModal,
    setOpenModal
  } = useModalAction();
  return <Modal opened={openModal === MODAL.SEARCH} onClose={() => setOpenModal(null)} closeButtonProps={{
    size: 37,
    bg: 'transparent',
    icon: <Icons className="icon-pr-line-close" fontSize={37} />
  }} overlayProps={{
    bg: 'rgba(23, 26, 30, 0.95)'
  }} size="100%" classNames={classes}>
      <Container mt={24} size="lg">
        <Stack w="100%">
          <SearchAction />
          <SearchCategory />
          <SearchTopGames />
        </Stack>
      </Container>
    </Modal>;
};